export const authQueryKeys = {
  IDP_LIST: 'idpList',
  TWO_FA: 'twoFA',
  ME: 'me',
  SUBSCRIPTION_INFO: 'subscription_info'
}

export const authMutationKeys = {
  TWO_FA: 'login_two_fa_mutation',
  LOGGED_USER: 'login_logged_user_mutation',
  LOGIN: 'login_login_mutation',
  REFRESH: 'login_refresh_mutation',
  SAML_MUTATION: 'login_saml_mutation',
  EMAIL_MUTATION: 'login_email_mutation',
  RESET_PASSWORD_MUTATION: 'login_reset_password_mutation',
  START_TRIAL_MUTATION: 'start_trial_mutation'
}

export const authUserKey = 'user'
